import { Control } from 'ol/control';
import { svgLupe } from './utils';

export class SearchControls extends Control {
  constructor(options: {
    target?: string | HTMLElement | undefined,
    onSearch: (v: string) => void
  }) {

    const input = document.createElement('input');
    input.type = 'text';
    input.id = 'map_search_input';
    input.placeholder = 'Wpisz tu adres';

    const button = document.createElement('button');
    button.type = 'button';
    button.id = 'map_search_button';
    button.innerHTML = svgLupe;

    const element = document.createElement('div');
    element.className = 'search ol-unselectable ol-control';
    element.append(input);
    element.append(button);

    super({
      element,
      target: options?.target
    });

    button.addEventListener('click', (e: Event) => {
      event?.preventDefault();
      event?.stopPropagation();
      const value = `${input.value || ''}`;
      if (value.length >= 3) {
        options.onSearch(input.value);
      }
    }, false);

    input.addEventListener('input', (e) => {
      if (input.value.length >= 3) {
        options.onSearch(input.value);
      }
    });

  }
}
